import { SET_USER, LOGOUT_USER } from '../actionsList';
import Cookies from 'universal-cookie';
import { closeSocket } from '../../utils/socket.services';
const cookies = new Cookies();


function loginUser(state, action) {
    let auth = action.auth
    if (auth) {
        cookies.set('admintoken', auth.token, { path: '/' })
    }
}

function logoutUser(action) {
    // let auth = action.auth
    // if (auth?.token) {
    cookies.remove('admintoken', { path: '/' })
    closeSocket()

    // }
}

const user = store => next => action => {
    let result = next(action)
    if (action.type === SET_USER) {
        loginUser(store.getState(), action)
    }
    if (action.type === LOGOUT_USER) {
        logoutUser(action)
    }
    return result
}

export default user;
